import { getAndroidAppUrl } from '../config';

function readStoredClickId() {
  try {
    const raw = localStorage.getItem('utm')
    if (!raw) return null
    const parsed = JSON.parse(raw)
    return parsed?.utm_id ?? null
  } catch {
    return null
  }
}

/**
 * Android: прямой Play Store URL с referrer=clickid=<utm_id>, если click уже создан.
 */
export function getPlayStoreUrl() {
  return getAndroidAppUrl(readStoredClickId())
}
